// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { portfolioPositionsSlice } from '@shared/data-access/slices/portfolio-positions';
import { appStore as store } from '@advisor-app/store/store';
import {
  type PortfolioPositionsCurrent,
  type PositionsAnalysis,
} from '@shared/data-access/interfaces/redux/portfolio-state';
import type { Paths } from '@shared/data-access/interfaces/routes/paths';

export const handleWorkflow = (
  workflowType: string,
  currentPositions: PortfolioPositionsCurrent[],
  tablePositions: PositionsAnalysis[],
  navigate: (goTo: any) => void,
  path: Paths,
) => {
  const dispatch = store.dispatch;

  if (workflowType === 'new') {
    const newHoldings: PortfolioPositionsCurrent[] = [];

    tablePositions.forEach(position => {
      newHoldings.push({
        ticker: position.ticker,
        price: 1,
        qty: position.volume,
        unrealized_capital_gains: position.unrealized_capital_gains,
        harvesting: {
          percentage: 0,
          status: 1,
          replacement: '',
        },
      });
    });

    dispatch(
      portfolioPositionsSlice.actions.setCurrentPortfolioPositions(newHoldings),
    );
  } else {
    dispatch(
      portfolioPositionsSlice.actions.setCurrentPortfolioPositions(
        currentPositions,
      ),
    );
  }

  navigate(path);
};
